
import { RequestedValue$1 } from "../../../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { User_$reflection } from "../../../../Shared/User.js";
import { list_type } from "../../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationOnGetRequest } from "../../../../ErrorHandling.js";
import { getCustomerConfiguration } from "../../../../Requests/Configuration.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../../Communication.js";
import { Location_$reflection } from "../../../../Shared/Location.js";
import { UserRoleAssignmentDto_$reflection, RoleDefinition_$reflection } from "../../../../Shared/Roles.js";

export function init() {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, []), new RequestedValue$1(0, [])), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(User_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/receivers/users", (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(5, [Item_1]))), getCustomerConfiguration((Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(5, [Item_3]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
        const pr_1 = response_2.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_4) => (new Msg(1, [Item_4])), (Item_5) => (new Msg(5, [Item_5]))), Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_8;
        return ((url_8 = addPrefix(url_6), (refreshOn_1) => fetchWithDecoder(url_8, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_3) => {
            const pr_2 = response_3.arrayBuffer();
            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(RoleDefinition_$reflection())));
        }, refreshOn_1)))(true).then((_arg_1) => {
            const result_4 = _arg_1;
            return (result_4.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_4.fields[0]);
            })())) : (Promise.resolve(result_4.fields[0]));
        });
    })), "/api/roles", (Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(5, [Item_7]))), Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_11;
        return ((url_11 = addPrefix(url_9), (refreshOn_2) => fetchWithDecoder(url_11, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_5) => {
            const pr_3 = response_5.arrayBuffer();
            return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), list_type(UserRoleAssignmentDto_$reflection())));
        }, refreshOn_2)))(true).then((_arg_2) => {
            const result_6 = _arg_2;
            return (result_6.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_6.fields[0]);
            })())) : (Promise.resolve(result_6.fields[0]));
        });
    })), "/api/roles/assignments", (Item_8) => (new Msg(4, [Item_8])), (Item_9) => (new Msg(5, [Item_9])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.CustomerConfiguration, state.Locations, state.Roles, state.Assignments), Cmd_none()];
        case 1:
            return [new State(state.Users, state.CustomerConfiguration, new RequestedValue$1(1, [msg.fields[0]]), state.Roles, state.Assignments), Cmd_none()];
        case 3:
            return [new State(state.Users, state.CustomerConfiguration, state.Locations, new RequestedValue$1(1, [msg.fields[0]]), state.Assignments), Cmd_none()];
        case 4:
            return [new State(state.Users, state.CustomerConfiguration, state.Locations, state.Roles, new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
        case 5:
            return [state, Cmd_none()];
        default:
            return [new State(state.Users, new RequestedValue$1(1, [msg.fields[0]]), state.Locations, state.Roles, state.Assignments), Cmd_none()];
    }
}

